import styled from '@emotion/styled';

export const NaturalPersonViewDocumentSectionContainer = styled.div`
  margin-bottom: 50px;
`;
